export const DEFAULT_USER_ID = "default_user";
